// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1pibI","inner":"Footer_inner__2kzvU","nextIcon":"Footer_nextIcon__2akh1","innerLeft":"Footer_innerLeft__qO7Kn"};